import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
    backgroundColor: 'transparent !important',
    boxShadow: 'none'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  }));

export default function SearchInput(props) {
    const classes = useStyles();

    return (
      <Paper component="form" className={classes.root} css={`${props.disabled? 'border: 1px solid #C4C4CD': 'border: 1px solid #000'}`} onSubmit={(e) => {e.preventDefault(); props.onSearch();}}>
        <InputBase
            className={classes.input}
            placeholder={props.placeholder}
            value ={props.value}
            disabled={props.disabled}
            onChange ={(e) => props.onChange(e.target.value)}
        />
        {
            props.value ? 
            <IconButton type="button" className={classes.iconButton} aria-label="clear" disabled={props.disabled} onClick={(e) => {e.preventDefault(); props.onClear();}}>
                <ClearIcon />
            </IconButton> : null
        }

        <IconButton type="submit" className={classes.iconButton} aria-label="search" disabled={props.disabled} onClick={(e) => {e.preventDefault(); props.onSearch();}}>
          <SearchIcon />
        </IconButton>
      </Paper>
    )

}